import { render, staticRenderFns } from "./LoaderBalls.vue?vue&type=template&id=aff555fc&"
import script from "./LoaderBalls.vue?vue&type=script&lang=ts&"
export * from "./LoaderBalls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports